export const CONTENT_MODAL_QUERY_PARAM = "contentModal";
